<template>
  <div>
    <span class="subtitle-1">{{ $t("logLegend") }}</span>
  </div>
</template>

<script>
export default {
  name: "views-backoffice-administrator-system-searchLogs",
  data: () => ({}),
  computed: {
    rangeDate() {
      return this.$store.state.range.date;
    },
    logLevel() {
      return this.$store.state.filters.selectUserLogLevel.value;
    },
    actions() {
      return this.$store.state.filters.selectActionLog.value;
    },
    userLogin() {
      return this.$store.state.filters.inputStringLog.value;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },
  },
  watch: {
    saveFilters(val) {
      val && this.getLogs();
    },
  },
  mounted() {
    // this.$store.commit("setGroupExport", "csv");
  },
  methods: {
    async getLogs() {
      const body = {
        ...this.rangeDate,
        log_level: this.logLevel,
        user_login: this.userLogin,
        action: this.actions,
        export: this.exportDoc,
      };

      let response;
      if (this.exportDoc) {
        const extension = this.exportDoc;
        const exportName = this.logLevel;
        response = await this.$request.exportDoc(
          "administrator/logs/export",
          body,
          extension,
          this.rangeDate,
          exportName
        );
      } else {
        response = await this.$request.post("administrator/logs/list", body);
      }
      if (!response.dados) return;
    },
  },
};
</script>
